import React from 'react';

import {useStore} from 'effector-react';
import {TFunction} from 'i18next';
import {useTranslation} from 'react-i18next';

import {EndlessList} from 'components/ui-kit/EndlessList';
import {commonDataState$} from 'models/documents/details';
import {
    listState$,
    sortingChanged,
    filtersChanged,
    Gate,
} from 'models/documents/details/updProducts/list';
import {ProductsUPDItem, ProductsUPDAccessors} from 'types/documents';

import {ListRow, FlexRowElement, Text, RowElement} from './styled';

interface Props {
    reportId: string;
    configFunc: (t: TFunction) => Array<any>;
    dataMapper: (data: ProductsUPDItem[] | undefined, t: TFunction) => ProductsUPDItem[];
}

export const ProductsList = ({reportId, configFunc, dataMapper}: Props) => {
    const {t} = useTranslation();
    const {data: commonData} = useStore(commonDataState$);
    const {data, sorting, filters, pageIncremented} = useStore(listState$);
    const mappedData = React.useMemo(() => dataMapper(data, t), [dataMapper, data, t]);

    return (
        <>
            <Gate reportId={reportId} />
            <EndlessList<ProductsUPDItem>
                rows={mappedData}
                totalRowsCount={commonData?.productsTotalCount}
                hasMore={data.length < (commonData?.productsTotalCount || 0)}
                renderRow={(row: ProductsUPDItem) => (
                    <ListRow>
                        <FlexRowElement>
                            <Text>{row[ProductsUPDAccessors.productGroupCode]}</Text>
                        </FlexRowElement>
                        <RowElement>
                            <Text>{row[ProductsUPDAccessors.gtin]}</Text>
                        </RowElement>
                        <RowElement>
                            <Text>{row[ProductsUPDAccessors.productName]}</Text>
                        </RowElement>
                        <RowElement>
                            <Text>{row[ProductsUPDAccessors.quantity]}</Text>
                        </RowElement>
                    </ListRow>
                )}
                onNextPage={() => pageIncremented()}
                config={configFunc(t)}
                sorting={sorting}
                filters={filters}
                onFiltersChange={filtersChanged}
                onSortingChange={sortingChanged}
            />
        </>
    );
};
